module.exports = __webpack_public_path__ + "img/geocomposto1.217c2535.png";